// todo: get this from gds-api
export const maxConcurrentSessionOptions = Array.from({ length: 100 }, (_, i) => ({
  value: i + 1,
  label: String(i + 1),
}));
